// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"292":"844475ab","488":"aa20c3f1","661":"aa20c3f1","2080":"af43caa5","4367":"844475ab","5172":"b22338b8","5446":"a0d1554e"}[chunkId] + ".chunk.css";
};